// quote related
var singleQuoted = /'[^']*'/;
var doubleQuoted = /"[^"]*"/;
var quoted = new RegExp("".concat(singleQuoted.source, "|").concat(doubleQuoted.source));
var quoteBalanced = new RegExp("(?:".concat(quoted.source, "|[^'\"])*")); // basic types

var integer = /-?\d+/;
var number = /-?\d+\.?\d*|\.?\d+/;
var bool = /true|false/; // peoperty access

var identifier = /[\w-]+/;
var subscript = new RegExp("\\[(?:".concat(quoted.source, "|[\\w-\\.]+)\\]"));
var literal = new RegExp("(?:".concat(quoted.source, "|").concat(bool.source, "|").concat(number.source, ")"));
var variable = new RegExp("".concat(identifier.source, "(?:\\.").concat(identifier.source, "|").concat(subscript.source, ")*")); // range related

var rangeLimit = new RegExp("(?:".concat(variable.source, "|").concat(number.source, ")"));
var range = new RegExp("\\(".concat(rangeLimit.source, "\\.\\.").concat(rangeLimit.source, "\\)"));
var rangeCapture = new RegExp("\\((".concat(rangeLimit.source, ")\\.\\.(").concat(rangeLimit.source, ")\\)"));
var value = new RegExp("(?:".concat(variable.source, "|").concat(literal.source, "|").concat(range.source, ")")); // hash related

var hash = new RegExp("(?:".concat(identifier.source, ")\\s*:\\s*(?:").concat(value.source, ")"));
var hashCapture = new RegExp("(".concat(identifier.source, ")\\s*:\\s*(").concat(value.source, ")"), 'g'); // full match

var tagLine = new RegExp("^\\s*(".concat(identifier.source, ")\\s*([\\s\\S]*)\\s*$"));
var literalLine = new RegExp("^".concat(literal.source, "$"), 'i');
var variableLine = new RegExp("^".concat(variable.source, "$"));
var numberLine = new RegExp("^".concat(number.source, "$"));
var boolLine = new RegExp("^".concat(bool.source, "$"), 'i');
var quotedLine = new RegExp("^".concat(quoted.source, "$"));
var rangeLine = new RegExp("^".concat(rangeCapture.source, "$"));
var integerLine = new RegExp("^".concat(integer.source, "$")); // filter related

var valueDeclaration = new RegExp("(?:".concat(identifier.source, "\\s*:\\s*)?").concat(value.source));
var valueList = new RegExp("".concat(valueDeclaration.source, "(\\s*,\\s*").concat(valueDeclaration.source, ")*"));
var filter = new RegExp("".concat(identifier.source, "(?:\\s*:\\s*").concat(valueList.source, ")?"), 'g');
var filterCapture = new RegExp("(".concat(identifier.source, ")(?:\\s*:\\s*(").concat(valueList.source, "))?"));
var filterLine = new RegExp("^".concat(filterCapture.source, "$"));
var operators = [/\s+or\s+/, /\s+and\s+/, /==|!=|<=|>=|<|>|\s+contains\s+/];

function isInteger(str) {
  return integerLine.test(str);
}

function isLiteral(str) {
  return literalLine.test(str);
}

function isRange(str) {
  return rangeLine.test(str);
}

function isVariable(str) {
  return variableLine.test(str);
}

function matchValue(str) {
  return value.exec(str);
}

function parseLiteral(str) {
  var res = str.match(numberLine);

  if (res) {
    return Number(str);
  }

  res = str.match(boolLine);

  if (res) {
    return str.toLowerCase() === 'true';
  }

  res = str.match(quotedLine);

  if (res) {
    return str.slice(1, -1);
  }

  throw new TypeError("cannot parse '".concat(str, "' as literal"));
}

module.exports = {
  quoted,
  number,
  bool,
  literal,
  filter,
  integer,
  hash,
  hashCapture,
  range,
  rangeCapture,
  identifier,
  value,
  quoteBalanced,
  operators,
  quotedLine,
  numberLine,
  boolLine,
  rangeLine,
  literalLine,
  filterLine,
  tagLine,
  isLiteral,
  isVariable,
  parseLiteral,
  isRange,
  matchValue,
  isInteger
};